import React from "react";

import { NoticeMessage } from "UI/FnrNoticeMessage";
import { colors } from "UI/colors";

export default function ExtendedFieldErrorMessage({ className, children }) {
  if (!children) return null;

  const styles = {
    fontWeight: 400,
    marginTop: 6,
  };

  return (
    <NoticeMessage styles={styles} align="start" bold>
      {children}
    </NoticeMessage>
  );
}
